import { Lock } from 'lucide-react'
import { cn } from '@/utils/cn'

interface LockBadgeProps {
  variant?: 'gold' | 'violet'
  className?: string
}

export function LockBadge({ variant = 'gold', className }: LockBadgeProps) {
  return (
    <div 
      className={cn(
        "flex items-center justify-center size-5 rounded",
        variant === 'gold' 
          ? "bg-amber-500/20 text-amber-400" 
          : "bg-violet-500/20 text-violet-400",
        className
      )}
    >
      <Lock className="size-3" />
    </div>
  )
}
